import styled from "styled-components";

export const AssignRoleCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
  text-align: center;
`;

export const AssignRoleDescription = styled.p`
  margin: 0;
  color: ${(props) => props.theme.colors?.greyFour || "#6B7280"};
  font-size: 14px;
  line-height: 140%;
`;

export const SelectedRolesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  width: 100%;
`;

export const SelectedRoleCardContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
`;

export const SelectedRoleInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
`;

export const SelectedRoleActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const ViewDetailsLink = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${(props) => props.theme.colors?.primary || props.theme.colors?.blue || "#1D4ED8"};
  font-family: ${(props) => props.theme.typography?.link?.regular?.family || "Inter"};
  font-weight: ${(props) => props.theme.typography?.link?.regular?.weight || 400};
  font-size: ${(props) => props.theme.typography?.link?.regular?.size || "14px"};
  line-height: 100%;
  text-decoration: underline;
  text-decoration-style: solid;
  text-decoration-color: currentColor;
  text-decoration-line: underline;
  text-decoration-thickness: 0%;
  text-decoration-offset: 0%;
  padding: 0;
`;

